import { Actions, Subjects, UISubjects, type CompleteRuleSet } from './abilityTypes'

export const LEADER_RULES = {
  [Subjects.USER]: () => [],
  [Subjects.USER_DETAIL]: () => [{ actions: [Actions.READ] }],
  [Subjects.ATTENDANCE]: () => [{ actions: [Actions.READ, Actions.WRITE] }],
  [Subjects.CHANGE_MY_PASSWORD]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.PROJECT]: () => [{ actions: [Actions.READ, Actions.WRITE] }],
  [Subjects.PROJECT_CREATE]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.PROJECT_USER]: () => [{ actions: [Actions.READ] }],
  [Subjects.PROJECT_SALES_COST]: () => [{ actions: [Actions.READ] }],
  [Subjects.USER_PROJECT]: () => [{ actions: [Actions.READ] }],
  [Subjects.ADD_PROJECT]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.RESOURCE_PLAN]: () => [{ actions: [Actions.READ] }],
  [Subjects.ASSIGN_BY_VOLUMED]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.VOLUMED_ASSIGN]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.CLIENT]: () => [],
  [Subjects.DEPARTMENT]: () => [],
  [Subjects.PARTNER]: () => [],
  [Subjects.JOB_SKILL]: () => [],
  [Subjects.JOB_TITLE]: () => [],
  [Subjects.HOLIDAY]: () => [],
  [Subjects.JOB]: () => [],
  [Subjects.CUSTOM_FIELD]: () => [],
  [Subjects.SETTING]: () => [],

  // UISubjects
  [UISubjects.PROJECT_LIST_COPY_BUTTON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.PROJECT_LIST_DELETE_BUTTON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.RESOURCE_PLAN_ADD_USER_BUTTON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_ADD_BUTTONS]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN_ICON]: () => [
    { actions: [Actions.SHOW] }
  ],
  [UISubjects.PROJECT_SALES_COST_EDIT_BUTTON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.PROJECT_SALES_COST_ADD_COST_BUTTON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN_ICON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.PROJECT_USER_ASSIGN_USER]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.PROJECT_USER_EDIT_ASSIGN_ICON]: () => [{ actions: [Actions.SHOW] }],
  [UISubjects.ADD_PROJECT_EDIT_ASSIGN]: () => [{ actions: [Actions.SHOW] }]
} satisfies CompleteRuleSet
